import { AdminApi } from 'stylemix-vue-admin'

export default class ApplicationApi extends AdminApi {
  constructor(parameters) {
    super('contract-templates', parameters)
  }
}
